<script lang="ts">
    import {getLocalization} from 'src/core';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';

    const localize = getLocalization();

    function redirect() {
        (window.top ?? window).location.href = '/auth/loginticket/start'; // Keycloak and the login broker refuse to show in an iframe
    }
</script>

<div class="login-system login-system-loginticket">
    <KpButton buttonStyle="primary" isBlock dataQa="loginticket-login-button" on:click={redirect}>
        {localize(/* @kp-localization login.AdminLogin */ 'login.AdminLogin')}
    </KpButton>
</div>
